var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7540_14191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.92871,
    y: 0.252563,
    width: 20,
    height: 20,
    transform: "rotate(15 5.92871 0.252563)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7540_14191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96409 16.7311L5.49252 14.759L6.45844 15.0178L7.76332 10.148C8.10482 8.87348 8.80098 7.845 9.8518 7.06253C10.9026 6.28007 12.0896 5.91512 13.4128 5.9677L13.6554 5.06215C13.7482 4.71562 13.9487 4.45358 14.2569 4.27603C14.5649 4.09861 14.8926 4.05642 15.2398 4.14945C15.587 4.24248 15.8488 4.44262 16.0253 4.74988C16.2018 5.05728 16.2436 5.38424 16.1507 5.73076L15.9081 6.63632C17.0802 7.25235 17.9303 8.1581 18.4584 9.35355C18.9864 10.549 19.0771 11.7934 18.7306 13.0866L17.4257 17.9565L18.3917 18.2153L17.8632 20.1874L4.96409 16.7311ZM10.6868 21.1115C10.2206 20.9866 9.86754 20.7146 9.62758 20.2954C9.38758 19.8764 9.32985 19.4344 9.45441 18.9696L12.8352 19.8754C12.7093 20.345 12.4364 20.6996 12.0163 20.9393C11.5962 21.179 11.153 21.2364 10.6868 21.1115Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.9273a97f89c252327292ac5d8b246380.svg";
export { ForwardRef as ReactComponent };